// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"
import type { DataType, DetailType } from "../../types"

// Utils
import { useApi } from "utils"

export function useDetail(reject_id: string): {
  data: DataType | null
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<DataType | null>(null)
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(
      "/proreject/detailreject",
      { params: { reject_id } }
    ).then((res: SuccessFetch<{
      payload: {
        datareject: {
          reject_id: number
          trx_code: string
          vendor_id: number
          location_id: number
          address: string
          transaction_date: string
          reject_status: number
          approve_status: number
          approve_by: string | null
        }
        detailreject: DetailType[]
      }
    }>) => {
      // Vars
      const payload = res.data.payload
      const datareject = payload.datareject

      setData({
        address: datareject.address,
        approve_by: datareject.approve_by ?? "-",
        approve_status: datareject.approve_status,
        location_id: datareject.location_id,
        reject_id: datareject.reject_id,
        reject_status: datareject.reject_status,
        trx_code: datareject.trx_code,
        vendor_id: datareject.vendor_id,
        transaction_date: datareject.transaction_date,
        detailreject: payload.detailreject
      })
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}